import React from 'react'
import {
  Card, CardHeader, Row, Col, Badge, CardBody
} from 'reactstrap'
import { Line } from 'react-chartjs-2'
import Monetario from '../Monetario'

const options = {
  plugins: {
    datalabels: {
      display: true,
      color: "black",
      align: "end",
      anchor: "end",
      font: { size: "14" }
    }
  },
  legend: {
    display: false,
    position: "left"
  },
  tooltips: {
    enabled: true,
  },
  scales: {
    yAxes: [
      {
        ticks: {
          display: true
        },
        gridLines: {
          drawBorder: true,
          zeroLineColor: "transparent",
          color: "rgba(128,128,128,0.2)"
        }
      }
    ],
    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent"
        },
        ticks: {
          display: true
        }
      }
    ]
  }
}

const LinhaCard = ({ title, color, dados })  => {
  const corLinha = ["#1b85b8", "#5a5255", "#559e83", "#ae5a41", "#c3cb71", "#96ceb4", "#ffeead", "#ff6f69", "#ffcc5c", "#88d8b0", "#337ab7", "#5cb85c", "#5bc0de", "#f0ad4e", "#3071a9", "#c7254e", "#00bdd5", "#01978b", "#8bc24a", "#cddc39"]
  const datasets = []
  for (let index = 0; index < dados.lojas.length; index++) {

    datasets[index] = {
      borderColor: corLinha[index],
      backgroundColor: corLinha[index],
      pointRadius: 0,
      pointHoverRadius: 0,
      borderWidth: 3,
      data: dados.valores[index]
      // data: index
    }

    // console.log("dataset "+corLinha[index]);
    // console.log("dataset "+datasets[index].data);
    // console.log("dataset "+datasets[index]);
  }
  // console.log("dados "+dados.lojas);
  console.log("dados "+datasets);

  const data = {
    labels: dados.lojas,
    datasets
  }


  return (
    <Card>
      <CardHeader>
        <Row>
          <Col sm="7">
            <div className="numbers pull-left grafico-valor"><Monetario valor={dados.total}/></div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className={color} pill>
                {title}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      
      <CardBody>
        <Line
          data={data}
          options={options}
          width={550}
          height={300}
        />
      </CardBody>
    </Card>
  )
}
export default LinhaCard
